import React from 'react';
import { PawPrint } from 'lucide-react';
import { faithfulSteedFreeCasts, faithfulSteedFreeRemaining, getPaladinLevel, hasPaladinFeature } from '../../../shared/rules/paladin.mjs';

/**
 * Faithful Steed tile (Paladin 5): casts the feature's free Find Steed (level 2, an Action) with no slot picker.
 * Slot casts of the always-prepared spell go through its Features card. The sheet then asks for the steed’s creature type and summons it.
 */
export default function FaithfulSteedControls({ form, characterId, combatState, isActiveTurn, blockReason, onCast }) {
  if (!hasPaladinFeature(form, 'faithfulSteed')) return null;
  const maximum = faithfulSteedFreeCasts(getPaladinLevel(form));
  const remaining = faithfulSteedFreeRemaining(form);
  const inCombat = Number.isInteger(combatState?.activeTurn) && Boolean(combatState?.participants?.[combatState.activeTurn]);
  const ledger = combatState?.turnActionLedger?.combatantId === String(characterId) && combatState.turnActionLedger.turnSequence === combatState.turnSequence ? combatState.turnActionLedger : null;
  const available = remaining > 0 && !blockReason && (!inCombat || (isActiveTurn && !ledger?.actionSpent));
  const title = blockReason || (remaining > 0
    ? 'Faithful Steed · Find Steed (level 2) · Action · no spell slot. Choose Celestial, Fey or Fiend; your steed appears beside you.'
    : 'Faithful Steed · no free cast until a Long Rest (cast Find Steed with a slot from Features)');
  return (
    <button type="button" data-action-tile="faithful-steed" className="combat-hud-resource-tile combat-hud-feature-action-tile" style={{ '--hud-resource-accent': '#c9a66b' }}
      title={title} aria-label={`Faithful Steed: ${remaining} of ${maximum} uses`} disabled={!available} onClick={() => onCast?.()}>
      <span className="combat-hud-resource-tile__icon" aria-hidden="true"><PawPrint size={20} /></span>
      <span className="combat-hud-resource-tile__name">Faithful Steed</span>
      <span className="combat-hud-resource-tile__value">{remaining}/{maximum}</span>
    </button>
  );
}
